import { useTranslate } from '@ur-solutions/react-hooks'
import { Module } from 'modules/companies/consts'
import React, { useState } from 'react'
import { Header, InfoBox, Section, SettingsWrapper } from '../components'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'
import { VehicleSelect } from 'components/Select'
import { AllVehicleExpirationDates } from 'modules/vehicles/fleet/components/AllVehicleExpirationDates'
import styled from 'styled-components'

const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledVehicleSelect = styled(VehicleSelect)`
  max-width: 400px;
`

interface VehicleFleetSettingsProps {}

export const VehicleFleetSettings: React.FC<VehicleFleetSettingsProps> = () => {
  const translations = useTranslate({
    info: 'settings.info.vehicles',
    vehicleExpirations: 'vehicles.expiration-dates',
    documentsAndExpirations: 'common.documents-and-expirations',
  })
  const [vehicleId, setVehicleId] = useState<string | null>(null)

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox>
        <p>{translations.info}</p>
      </InfoBox>

      <Header></Header>

      <ModuleResponsibleUsers module={Module.VEHICLES} />

      <Section>
        <StyledHeader>
          <h2>{translations.documentsAndExpirations}</h2>
          <StyledVehicleSelect
            onVehicleSelectedCallback={vehicle =>
              vehicle ? setVehicleId(vehicle.id) : setVehicleId(null)
            }
            nullable
          />
        </StyledHeader>
        <AllVehicleExpirationDates vehicleId={vehicleId} />
      </Section>
    </SettingsWrapper>
  )
}
